const initialValue = {
  type: "paragraph",
  children: [{ text: "A line of text in a paragraph." }],
};

export default initialValue;
